import { useEffect } from 'react';
import { useRouteError } from 'react-router';
import { reloadOnceOnChunkError } from '@qs/ui/lib/chunkReload';

// 画面のエラーをサーバーのログに送る（スマホで起きたことを開発機で調べられるように）
let sent = 0;
export function reportClientError(kind: string, err: unknown) {
  if (sent >= 10) return;
  sent += 1;
  const e = err instanceof Error ? err : new Error(String(err));
  const body = {
    kind,
    message: e.message.slice(0, 500),
    stack: (e.stack ?? '').slice(0, 2000),
    url: location.pathname,
    ua: navigator.userAgent.slice(0, 300),
  };
  try {
    void fetch('/api/client-errors', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), keepalive: true }).catch(() => {});
  } catch {
    // 送れなくても画面は止めない
  }
}

/** 描画以外で起きたエラー（イベント・非同期）も送る */
export function installErrorReporting() {
  window.addEventListener('error', (ev) => reportClientError('error', ev.error ?? ev.message));
  window.addEventListener('unhandledrejection', (ev) => reportClientError('unhandledrejection', ev.reason));
}

/** 画面の描画でエラーが起きたとき：真っ白にせず、再読み込みを案内する（大会への参加は端末キーで元に戻る） */
export function AppError() {
  const err = useRouteError();
  // 部品の読み込みの失敗（更新のあとなど）は、1回だけ自動で読み込み直す
  useEffect(() => {
    if (!reloadOnceOnChunkError(err)) reportClientError('render', err);
  }, [err]);
  const message = err instanceof Error ? err.message : String(err);
  return (
    <div style={{ minHeight: '100vh', padding: 24, display: 'flex', flexDirection: 'column', gap: 16, alignItems: 'center', justifyContent: 'center', textAlign: 'center', background: 'var(--color-surface)' }}>
      <h1 style={{ font: 'var(--type-heading-2)', margin: 0 }}>画面を表示できませんでした</h1>
      <p style={{ margin: 0, lineHeight: 1.7, color: 'var(--color-ink-muted)' }}>
        再読み込みすると、大会の続きから戻れます。
        <br />
        何度も起きるときは、主催者に知らせてください。
      </p>
      <button
        type="button"
        onClick={() => location.reload()}
        style={{ height: 56, padding: '0 32px', border: 0, borderRadius: 14, background: 'var(--color-blue)', color: 'var(--color-surface)', font: 'var(--type-button)', fontSize: 18, cursor: 'pointer' }}
      >
        再読み込み
      </button>
      <small style={{ color: 'var(--color-ink-muted)', wordBreak: 'break-all' }}>{message}</small>
    </div>
  );
}
